import React from "react";

import { Image, Box, Badge } from "@chakra-ui/react";

import { StarIcon } from "@chakra-ui/icons";
import styled from "@emotion/styled";

function SingleCard(props) {
  return (
    <MainDiv href="/login">
      <Box
        maxW="300px"
        height="450px"
        width="400px"
        borderWidth="1px"
        borderRadius="lg"
        overflow="hidden"
      >
        <Image
          objectFit="cover"
          width="720px"
          height="223.5px"
          src={props.property.images[0]}
        />

        <Box p="6">
          <Box d="flex" alignItems="baseline">
            <Badge borderRadius="full" px="2" color="#EE575D">
              New
            </Badge>
            <Box
              color="gray.500"
              fontWeight="semibold"
              letterSpacing="wide"
              fontSize="xs"
              textTransform="uppercase"
              ml="2"
            >
              {props.property.beds} beds &bull; {props.property.bathroom} baths
            </Box>
          </Box>

          <Box
            height="48px"
            alignItems="center"
            display="flex"
            mt="1"
            fontWeight="semibold"
            as="h4"
            lineHeight="tight"
          >
            {props.property.description}
          </Box>

          <Box>
            {props.property.price}
            <Box as="span" color="gray.600" fontSize="sm">
              $ / night
            </Box>
          </Box>

          <Box d="flex" mt="2" alignItems="center">
            {Array(5)
              .fill("")
              .map((_, i) => (
                <StarIcon
                  key={i}
                  color={i < props.property.rating ? "#EE575D" : "gray.300"}
                />
              ))}
            <Box as="span" ml="2" color="gray.600" fontSize="sm">
              {props.property.reviews} reviews
            </Box>
          </Box>
        </Box>
      </Box>
    </MainDiv>
  );
}

export default SingleCard;

const MainDiv = styled.div`
  margin: 15px;
  cursor: pointer;
  min-width: 200px;
`;
